import { View } from 'react-native';

const ListItemElement = View;

export { ListItemElement };
